export default __webpack_public_path__ + "static/media/799.2c4ff0ab.gif";